import '../../assets/css/main.css';
import {useState, useEffect, useRef, useCallback} from 'react';
import { Link } from 'react-router-dom';
import main_bg from '../../assets/videos/main_bg.mp4';

/**
 * 메인 페이지 컴포넌트
 */
const Main = () => {
    const [isQuickMenuOpen, setIsQuickMenuOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const slideWrapperRef = useRef(null);
    const quickWrapRef = useRef(null);
    const intervalRef = useRef(null);

    const slides = [
        { id: 1, text: <><span>주체</span>는 근대 교육에 주요 역할을 한 선생님, 학생 등 <br class="hide-pc"/>교육에 참여한 다양한 사람들.</> },
        { id: 2, text: <><span>공간</span>은 교육이 이루어진 장소, <br class="hide-pc"/>즉 학교와 그 환경.</> },
        { id: 3, text: <><span>경험</span>은 학생과 선생님이 겪었던 <br class="hide-pc"/>실제 교육의 순간들.</> }
    ];

    const moveSlide = useCallback(() => {
        if (isAnimating || !slideWrapperRef.current) return;

        const wrapper = slideWrapperRef.current;
        const firstItem = wrapper.firstElementChild;
        if (!firstItem) return;

        setIsAnimating(true);
        const height = firstItem.offsetHeight;

        // 애니메이션 시작
        wrapper.style.transition = 'transform 800ms ease-in-out';
        wrapper.style.transform = `translateY(-${height}px)`;

        // 애니메이션 종료 후 처리
        const handleTransitionEnd = () => {
            wrapper.style.transition = '';
            wrapper.style.transform = '';
            wrapper.appendChild(firstItem);
            setIsAnimating(false);
        };

        const transitionEndListener = () => {
            handleTransitionEnd();
            wrapper.removeEventListener('transitionend', transitionEndListener);
        };

        wrapper.addEventListener('transitionend', transitionEndListener);
    }, [isAnimating]);

    // 자동 슬라이드 시작
    useEffect(() => {
        const startAutoPlay = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            intervalRef.current = setInterval(moveSlide, 5000);
        };

        startAutoPlay();

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [moveSlide]);

    // 퀵메뉴 외부 클릭 감지
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (quickWrapRef.current && !quickWrapRef.current.contains(event.target)) {
                setIsQuickMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleQuickMenu = (e) => {
        e.stopPropagation();
        setIsQuickMenuOpen(!isQuickMenuOpen);
    };

    return (
        <main id="contents">
            <div className="main-content">
                <div className="w-set">
                    <div className="main-section">
                        <div className="bg-video">
                            <div className="video-box">
                                <video className="video" autoPlay muted loop preload="metadata">
                                    <source src={main_bg} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                        <div className="main-text">
                            <p className="tit">
                                <span>'주체, 공간, 경험'</span>
                                을 중심으로 근대 교육의 주요 순간을 기록합니다.
                            </p>
                            <div className="text-wrap">
                                <div className="text-slides">
                                    <ul className="slides-wrapper" ref={slideWrapperRef}>
                                        {slides.map((slide, index) => (
                                            <li key={slide.id} >
                                                {slide.text}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="quick-wrap" ref={quickWrapRef}>
                            <button
                                type="button"
                                className={`btn-quick ${isQuickMenuOpen ? 'on' : ''}`}
                                onClick={toggleQuickMenu}
                            >
                                <div className="quick-round"></div>
                                <p>
                                    <span>MENU</span>
                                    <span>메뉴 안내</span>
                                </p>
                                <em></em>
                            </button>
                            <div className={`quick-menu ${isQuickMenuOpen ? 'on' : ''}`}>
                                <Link to="/person_search" className="menu1">
                                    <i className="i-menu"></i>
                                    <p>학생과 교원정보</p>
                                    <span>바로가기</span>
                                </Link>
                                <Link to="/school_search" className="menu2">
                                    <i className="i-menu"></i>
                                    <p>조선제학교일람을 통해서 <br/>본 근대학교 변천</p>
                                    <span>바로가기</span>
                                </Link>
                                <Link to="/biography_about" className="menu3">
                                    <i className="i-menu"></i>
                                    <p>회고록에 등장하는 <br/>교육경험</p>
                                    <span>바로가기</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Main;